import React from 'react';
import { FuelTypography } from '@frete.com/fuel-react';
import { formatDateToPatternRequested } from '@utils/formatters';
import Pulse, { PulsePropsInterface } from '../Pulse';
import { TrackingTimelinePropsInterface } from './TrackingTimelineTypes';
import * as Styled from './TrackingTimelineStyles';

function TrackingTimeline({ data, name }: TrackingTimelinePropsInterface) {
  function renderPulse() {
    return data.map((item, index) => {
      const isFirstItem = index === 0;
      const label: PulsePropsInterface['label'] = {
        text: item.label,
        size: 'sm' as 'lg' | 'sm',
        color: 'neutral-default',
        weight: 'bold',
      };
      const icon = {
        color: 'gray' as 'green' | 'gray',
        isPulse: false,
        name: 'one-check',
        inactive: item.inactive,
      };
      const { inactive } = item;

      const hasBorder = true;
      const date =
        item.date &&
        formatDateToPatternRequested(item.date, "HH:mm 'EM' dd MMM");

      if (isFirstItem) {
        icon.color = 'green';
        icon.isPulse = true;
        icon.name = '';
      }

      return (
        <Styled.Item
          key={`${name}-tracking-timeline-${item.label}`}
          border={hasBorder}
        >
          <Pulse label={label} icon={icon} inactive={inactive} />
          {date && (
            <Styled.WrapperDate>
              <FuelTypography
                size="overline"
                color="neutral-default"
                weight="bold"
              >
                {date}
              </FuelTypography>
            </Styled.WrapperDate>
          )}
          {item.description && (
            <Styled.WrapperChildren>
              <FuelTypography size="body-md" weight="bold">
                {item.description}
              </FuelTypography>
            </Styled.WrapperChildren>
          )}
        </Styled.Item>
      );
    });
  }

  return <ul>{renderPulse()}</ul>;
}

export default TrackingTimeline;
